import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/index';
import {checkIfUserDataAvailable} from "../../util/account_management";
import {
    checkIfBroadcasterVerified,
    checkIfMobileNumberIsVerified,
    checkIfRegisterBroadcaster,
    showMobileVerification
} from "../../util/broadcaster/register_util";
import {navigate} from "../../util/utility";

//image
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';

class PendingVerification extends Component {

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.hideLeftBar(); //hide the leftbar
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //check if we have user information
        if (checkIfUserDataAvailable(nextProps)) {

            //check if user has registered with us as a broadcaster
            if (checkIfRegisterBroadcaster(nextProps)) {

                //check if they have not verified their mobile number
                if (!checkIfMobileNumberIsVerified(nextProps)) {
                    showMobileVerification();
                } else if (checkIfBroadcasterVerified(nextProps)) {
                    //move to broadcaster create profile if not any
                    navigate(this.props, "////console.log");
                }
            }
        }

    }

    render() {

        return (
            <div>
                <main role="main" className="">
                    <div className="login-container">
                        <div className="row">
                            <div className="col-md-6 bg-primary d-flex align-items-center text-center" style={{borderRight:'1px solid #e7e7e7'}}>
                                <div className="login-content">
                                    <img src={vuepay_large_logo} className="img-fluid"/>
                                    {/* <h4 style={{color:'#FFFFFF'}}>Fancy yourself as a broadcaster?</h4>
                                    <p style={{color:'#FFFFFF'}}>Want to get closer to your fans?</p>
                                    <p style={{color:'#FFFFFF'}}>Want to offer a live experience?</p>
                                    <p style={{color:'#FFFFFF'}}>VuePay offers you a simple and effective solution to broadcast your live-stream around the world from anywhere in the world. Do you want to VuePay because fans want to chat to you!.</p> */}
                                </div>
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <div className="login-content-right">
                                    <h4>Your account is in a pending state</h4>
                                    <p>This is a holding page, please keep an eye on your notifications and wait to be
                                        approved by the administrator.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
    };
}

export default connect(mapStateToProps, actions)(PendingVerification);
